export default function ConnectionStatus({ isConnected }) {
  return isConnected ? (
    <div className="ml-auto flex items-center">
      <div className="w-2 h-2 rounded-full bg-green-500 mr-2"></div>
      <span className="text-xs text-green-600">Conectado</span>
    </div>
  ) : (
    <div className="ml-auto flex items-center">
      <div className="w-2 h-2 rounded-full bg-red-500 mr-2"></div>
      <span className="text-xs text-red-600">Desconectado</span>
    </div>
  )
}

